module.exports = __webpack_public_path__ + "static/media/modalImg7.74454437.png";